export enum NeverOutOfStockIconSize {
  SMALL = 'never-out-of-stock-icon-small',
  BIG = 'never-out-of-stock-icon-big',
}
